module.exports = __webpack_public_path__ + "static/media/2-en.754e6167.svg";